import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../store/auth.ts';
import { IconCloud } from '../lib/icons.tsx';

export function LoginPage() {
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : '로그인에 실패했습니다');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <form className="auth__card" onSubmit={(e) => { void submit(e); }}>
        <div className="auth__brand"><IconCloud size={26} /> YumSync</div>

        <div className="field">
          <label htmlFor="email">아이디 또는 이메일</label>
          <input
            id="email" className="input" type="text" autoComplete="username" required
            value={email} onChange={(e) => { setEmail(e.target.value); }}
          />
        </div>
        <div className="field">
          <label htmlFor="password">비밀번호</label>
          <input
            id="password" className="input" type="password" autoComplete="current-password" required
            value={password} onChange={(e) => { setPassword(e.target.value); }}
          />
        </div>

        {error && <p className="error-text" role="alert">{error}</p>}

        <button className="btn btn--primary btn--block" type="submit" disabled={busy}
          style={{ marginTop: 8, height: 40 }}>
          {busy ? <span className="spinner" /> : '로그인'}
        </button>

        <div className="auth__foot">
          계정이 없으신가요? <Link to="/signup">가입하기</Link>
        </div>
        <div className="auth__foot" style={{ marginTop: 8 }}>
          <a href="/download">PC 앱 다운로드</a>
        </div>
      </form>
    </div>
  );
}
